















import { defineComponent, ref } from '@vue/composition-api';
import StaffForm from '@/components/StaffForm.vue';
import { useMutations } from '@u3u/vue-hooks';
import router from '@/router';
import feathers from '@/feathers-client';

export default defineComponent({
  components: {
    StaffForm,
  },
  setup() {
    const { SHOW_SNACKBAR } = useMutations(['SHOW_SNACKBAR']);
    const dialog = ref(true);
    const loading = ref(false);
    const staffInfo = ref({
      name: '',
      last_name: '',
      locality: '',
      address: '',
      address_number: '',
      floor: '',
      department: '',
      postal_code: '',
      phone: '',
      email: '',
      shifts: '',
      zones: '',
    });

    const onSubmitStaffForm = async (formData: any) => {
      loading.value = true;
      try {
        const response = await feathers.service('staff').create(formData);
        const successText = `Hecho! Se han dado de alta con éxito el staff <strong>${response.last_name.toUpperCase()} ${response.name.toUpperCase()}</strong> 😄`;
        SHOW_SNACKBAR({ message: successText, color: 'success' });
        router.replace({ name: 'SearchStaff' });
      } catch (err) {
        let errorText = `Ups! Ocurrió un error al dar de alta el staff <strong>${err.hook.data.last_name.toUpperCase()} ${err.hook.data.name.toUpperCase()}</strong> 😕`;
        if (err.code === 409) errorText = 'Ups! El staff ya existe en la base de datos 😕';
        SHOW_SNACKBAR({ message: errorText, color: 'error' });
      } finally {
        loading.value = false;
      }
    };

    return {
      onSubmitStaffForm,
      staffInfo,
      dialog,
      loading,
    };
  },
});
